import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

/**
 * Det eneste som skiller lekeplassen visuelt fra søkerens skjema: en liten
 * merkelapp øverst, så ingen tror de fyller ut en ekte søknad.
 */
const PlaygroundBanner = () => {
    const { t } = useTranslation();

    return (
        <div
            className="position-fixed top-0 start-50 translate-middle-x mt-2 no-print"
            style={{ zIndex: 1100, pointerEvents: 'none' }}
            role="status"
        >
            <span className="badge rounded-pill text-bg-warning px-3 py-2 fw-medium shadow-sm" style={{ fontSize: 13 }}>
                <FontAwesomeIcon icon={['fal', 'flask']} className="me-2" />
                {t('playground_banner')}
            </span>
        </div>
    );
};

export default PlaygroundBanner;
